import { SupportPartnerKeySchema } from "@redotech/redo-support-partnerships-common/support-partnership";
import * as z from "zod";

export const deleteSupportPartnership = {
  name: "deleteSupportPartnership" as const,
  input: z.object({ partnerKey: SupportPartnerKeySchema }),
  output: z.object({}),
};
